<template>
    <b-col cols="12">
        <template v-if="price_management_interno">
            <template v-if="!footer.hide_iva_in_tickets">
                {{ $t('general.el_precio_sin_gastos', { precio: $n(price, "currency"), iva: iva_formatted }) }}
            </template>
            <template v-else>
                {{ $t('general.el_precio_sin_iva', { precio: $n(price, "currency")}) }}
            </template>
        </template>
        <template v-else>
            {{ $t('general.el_precio', { precio: $n(price, "currency"), gastos: $n(price_management, "currency"), iva: iva_formatted }) }}
        </template>
    </b-col>
</template>

<script>
    export default {
        props: {
            price_management_interno: {
                type: Number,
                required: true
            },
            price_management: {
                type: Number,
                required: true
            },
            price: {
                type: [String, Number],
                required: true
            },
            iva: {
                type: Number,
                required: false
            },
            abonos: {
                type: Array,
                required: false
            }
        },
        computed: {
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            iva_formatted() {
                return this.iva ?? this.teatro.iva;
            }
        }
    }
</script>